import React, { useEffect, useState } from 'react';
import {Form, Input, Modal , Button,notification} from 'antd';
import changePasswordImage from '../../assets/changepassword.png';
import {Row, Col} from 'react-bootstrap'
import { useDispatch } from 'react-redux'; // Import useDispatch for dispatching actions
import {changePasswordAction} from '../../store/action/business/ChangepasswordAction';

const ChangePasswordModal = () => {

  const userName = localStorage.getItem('name')
  const [open, setOpen] = useState(false);
  const [form] = Form.useForm();
  const dispatch = useDispatch();


  useEffect(() => {
    setOpen(true);
  }, []);

  const validatePasswords = ({ getFieldValue }) => ({
    validator(_, value) {
      if (!value || getFieldValue('newPassword') === value) {
        return Promise.resolve();
      }
      return Promise.reject(new Error('New Passwords do not match!'));
    },
  });

    const handleChangePassword = (values) => {
      const takeToken = localStorage.getItem('accessToken')
      const payload = {
        password: values.newPassword,
        token:takeToken,
        onSuccess: () => {
          setOpen(false); // Close the modal after successful API response
          localStorage.setItem("firstLogin", "false");
        },
      }
      dispatch(changePasswordAction(payload))
  };
  

  return (
    <div>
      <Modal closable={false} centered open={open} width={1000} footer={null}>
       <div>
        <Row>
           <Col md={6}>
              <img style={{width:'100%', borderRadius:'10px'}} src={changePasswordImage} alt='changePasswordImage' />
           </Col>
           <Col md={6}>
              <h4 style={{ textTransform: 'capitalize',fontWeight:'600', color:'#575757'}}>Hi, {userName}</h4>
              <span style={{color:'#5f5f5f'}}>A strong password is your first shield against cyber threats—protect it wisely</span>

              <h6 className='mt-4' style={{fontFamily: 'sans-serif', color:'#737373'}}>Update your password</h6>

              <div>
                <Form form={form} autoComplete="off" layout="vertical"
                onFinish={handleChangePassword}>
              <Form.Item
                  label="New Password"
                  name="newPassword"
                  rules={[
                    { required: true, message: 'Please input your new password!' },
                    { min: 9, message: 'Password must be at least 8 characters!' },
                  ]}>
                  <Input.Password placeholder="Enter new password" />
                </Form.Item>
    
                {/* Confirm Password */}
                <Form.Item label="Confirm Password" name="confirmPassword" dependencies={['newPassword']}
                  rules={[
                    { required: true, message: 'Please confirm your password!' },
                    validatePasswords,
                  ]}>
                  <Input.Password placeholder="Confirm new password" />
                </Form.Item>
                <Form.Item style={{paddingTop:'15px', gap: '10px'}}>
                  <Button style={{height: '40px', width:'50%'}} type="primary" htmlType="submit" block>
                    Update Password
                  </Button>
                   {/* <Button style={{height: '40px', width:'50%', borderColor:'#ffff', color:'red'}} color="default" variant="text" onClick={()=> setOpen(false)}>
                    Remind me later 
                   </Button> */}
                </Form.Item>
                </Form>
              </div>
           </Col>
        </Row>
       </div>
      </Modal>
    </div>
  );
};

export default ChangePasswordModal;
